import React, {useEffect, useState} from 'react';
import { BrowserRouter, HashRouter, Route, Switch, useRouteMatch, useLocation, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from './katalMetrics/metricsModels';
import {getServiceForMetricsByPath, captureMetrics, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"

import TopNav from './TopNav';
import ATeamBIAllProducts from './Home/Home'
import AppRedirect from './Home/AppRedirect'
import GeneralTools from './general-tools/Home';
import Favorites from './Favorites';
import BoffinHome from './Ateam-BI/Boffin/Home'
import BoffinInputs from './Ateam-BI/Boffin/Inputs'

import BoffinCompute from './Ateam-BI/Boffin/Compute';

import BoffinViewAllItems from './Ateam-BI/Boffin//ViewAlltems'
import BoffinEditItem from './Ateam-BI/Boffin/EditItem'
import BoffinInputsHistory from './Ateam-BI/Boffin/InputsHistory'

import BoffinDashboards from './Ateam-BI/Boffin/Dashboards';
import BoffinNewOverride from './Ateam-BI/Boffin/NewOverride';
import BoffinRulesAndWarnings from './Ateam-BI/Boffin/RulesWarnings';
import BoffinRulesWarningsNewEdit from './Ateam-BI/Boffin/RulesWarningsNewEdit';
import BoffinTeamNameMapping from './Ateam-BI/Boffin/TeamNameMapping';
import BoffinCurrentPeriod from './Ateam-BI/Boffin/CurrentPeriod';
import BoffinSupplierMasterList from './Ateam-BI/Boffin/SupplierMasterList';
import BoffinWarningRules from './Ateam-BI/Boffin/WarningRules';
import BoffinCipTracker from './Ateam-BI/Boffin/CIPTracker';
import BoffinBuildingTracker from './Ateam-BI/Boffin/BuildingTracker';
import BoffinPostingSummary from './Ateam-BI/Boffin/PostingSummary';
import BoffinCategoryUELMapping from './Ateam-BI/Boffin/CategoryUELMapping'
import BoffinMappingBookToLedger from './Ateam-BI/Boffin/MappingBookToLedger'
import BoffinPrimaryLedgerToSecondaryLedgerMapping from './Ateam-BI/Boffin/PrimaryLedgerToSecondaryLedger'
import BoffinWarningRulesOverride from './Ateam-BI/Boffin/WarningRulesOverride'
import BoffinSupplierMasterListOverride from './Ateam-BI/Boffin/SupplierMasterListOverride'
import BoffinUnlockCompute from './Ateam-BI/Boffin/UnlockCompute';
// import BoffinMissingVendors from './Ateam-BI/Boffin/MissingVendors'

import TedHome from './Ateam-BI/Ted/Home';
import TriggerEventLogs from './Ateam-BI/Ted/TriggerEventLogs';
import TriggerHistory from './Ateam-BI/Ted/TriggerHistory';
import EmailSubscription from './Ateam-BI/Ted/EmailSubscription';
import EntityRegionMapping from './Ateam-BI/Ted/EntityRegionMapping';
import RegionTriggerMapping from './Ateam-BI/Ted/RegionTriggerMapping';
import MJEMonitoringHome from './Ateam-BI/MJEMonitoring/Home';
import MJEMonitoringNewUpload from './Ateam-BI/MJEMonitoring/NewUpload'
import MJEMonitoringHistory from './Ateam-BI/MJEMonitoring/History'
import AppTemplate from './Ateam-BI/TemplatedApp/AppTemplate';
import TemplateMaple from './Ateam-BI/Templates/TemplateMaple';
import AllTemplates from './Ateam-BI/TemplatedApp/AllTemplates';
import AdminPanel from './Ateam-BI/Admin/AdminPanel';
import FriscoWorkflow1 from './Ateam-BI/Frisco/FriscoWorkflow1';
import FriscoMainPage from './Ateam-BI/Frisco/FriscoMainPage';
import FriscoUploadPage from './Ateam-BI/Frisco/FriscoUploadPage';
import AddOrEditProcessPage from './Ateam-BI/Frisco/AddOrEditProcessPage';
import FriscoHistoryPage from './Ateam-BI/Frisco/FriscoHistoryPage';

import ApprovalsHome from './Approvals/approvalsHome';
import WorkflowInstance from './Approvals/workflowInstance';
import CorpReportingHome from './Ateam-BI/CorpReporting/Home';
import GroupPage from './Ateam-BI/CorpReporting/GroupPage';
import DeliverablesPage from './Ateam-BI/CorpReporting/DeliverablesPage';
import ModulesPage from './Ateam-BI/CorpReporting/ModulesPage';
import AdminPortal from './Ateam-BI/CorpReporting/AdminPortal';
import AppAuditLogging from './Ateam-BI/AuditLogging/AppAuditLogging';
import FriscoAuditLoggingPage from './Ateam-BI/AuditLogging/FriscoAuditLoggingPage';
import AllAuditLogs from './Ateam-BI/AuditLogging/AllAuditLogs';

import AddOrEditLogicoProcessPage from './Ateam-BI/Logico/AddOrEditLogicoProcessPage';
import LogicoHistoryPage from './Ateam-BI/Logico/LogicoHistoryPage';
import LogicoUploadPage from './Ateam-BI/Logico/LogicoUploadPage';
import AddOrEditTemplatePage from './Ateam-BI/FlexiCo/AddOrEditTemplatePage';
import FlexicoUploadPage from './Ateam-BI/FlexiCo/FlexicoUploadPage';
import FlexicoHistoryPage from './Ateam-BI/FlexiCo/FlexicoHistoryPage';
import FlexicoAuditLoggingPage from './Ateam-BI/FlexiCo/FlexicoAuditLoggingPage';
import FriscoRedirect from './Ateam-BI/Frisco/FriscoRedirect';
import FlexicoRedirect from './Ateam-BI/FlexiCo/FlexicoRedirect';

import ChampionsIntake from './Ateam-BI/Templates/QSCIntake';
import QSCAppMigrationDetails from './Ateam-BI/Templates/QSCAdditionalDetails';
import QSCAppChangeRequest from './Ateam-BI/Templates/QSCAppChangeRequest';
import RACIntake from './Ateam-BI/Templates/RACIntake';
import RACAppChangeRequest from './Ateam-BI/Templates/RACAppChangeRequest';
import FlexicoFileDetails from './Ateam-BI/FlexiCo/FlexicoFileDetails';
import * as KatalMetrics from '@amzn/katal-metrics';
import { Box, Flashbar } from '@amzn/awsui-components-react';
import FriscoFileDetails from './Ateam-BI/Frisco/FriscoFileDetails';
import Bowser from "bowser";
import useVisibleSessionDuration from 'src/katalMetrics/useVisibleSessionDuration';
import FirstPassHome from './Ateam-BI/FirstPass/FirstPassHome';
import FirstPassHistory from './Ateam-BI/FirstPass/FirstPassHistory';
import { BannerDisplayLocation } from './Ateam-BI/Banners/BannerTypes';
import BannerContainer from './Ateam-BI/Banners/BannerContainer';
import { ALTERNATIVE_APP_URLS } from './constants/AppConstants';

export const AppRouter: React.FC = () => {

    const [inIframe, setInIframe] = useState(window.self !== window.top)
    const ln = useLocation()
    const history = useHistory();
    const currentUser = useSelector((globalState: any) => globalState.auth.userId)
    const currentStage = useSelector((globalState: any)=>globalState.auth.currentStage)
    const currentApp = useSelector((globalState: any)=>globalState.auth.currentAppId)
    const [currentUrlPrefix, setCurrentUrlPrefix] = useState("");
    const [pageVisitActionPublisher, setPageVisitActionPublisher] = useState<KatalMetrics.Publisher>()
    useVisibleSessionDuration([{
        metricName : 'actionPerformedBy',
        metricValue : currentUser,
        metricType : METRIC_TYPE.STRING,
        isMonitor : true
     },
    ], "timeSpent", ACTION_METHODS.SESSION_DURATION, SITE_SERVICES.ACCOUNTING_BI_CENTRAL);


    useEffect(() => {
        const regex = /\/[a-zA-Z]+/;
        const urlprefix = ln.pathname.match(regex);
        urlprefix && setCurrentUrlPrefix(urlprefix[0])
    }, [ln.pathname])
    
    useEffect(() => {
        setInIframe(window.self !== window.top)
    }, [])

    useEffect(() => {
        if (!currentUser) return

        if(ln.pathname == '/ClosePortal') {
            history.push('/')
            return
        }

        if(ln.pathname?.toLowerCase()?.startsWith('/closeportal') && location.search?.startsWith('?resourceId')) {
            return
        }

        const browser = Bowser.getParser(window.navigator.userAgent);
        const metricConfig = [{
            metricName : 'actionPerformedBy',
            metricValue : currentUser,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'visitedPagePath',
            metricValue : `${ln.pathname}${location.search}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'browserName',
            metricValue : browser.getBrowserName(),
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'operatingSystem',
            metricValue : browser.getOSName(),
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'visitCount',
            metricValue : 1,
            metricType : METRIC_TYPE.COUNTER,
            isMonitor : true
        }]
        const pageVisitActionPublisher = captureMetrics(ACTION_METHODS.PAGE_VISIT, metricConfig, getServiceForMetricsByPath(ln.pathname))
        setPageVisitActionPublisher(pageVisitActionPublisher)
    }, [ln.pathname, currentUser])

    return (
        <>
            {inIframe ?
                <div style={{ display: "none" }}>
                    <TopNav />
                </div> : <>
                    {
                        currentStage != 'prod' ? <Box textAlign='center'>
                            <div className='banner_message'>
                                You are currently in a testing environment. For real business operations, please use the production environment: <a href='https://bi-central.accounting.amazon.dev'> https://bi-central.accounting.amazon.dev </a>
                            </div>
                        </Box> : <></>
                    }
                    {
                        <BannerContainer displayLocations={[BannerDisplayLocation.Everywhere, BannerDisplayLocation.UrlPrefix, BannerDisplayLocation.App]} roundedCorners={false} parameters={{urlPrefix: currentUrlPrefix, appId: currentApp}} />
                    }
                    <TopNav />
                </>}
            
            <Switch>
                <Route exact path="/" component={ATeamBIAllProducts}  />
                <Route exact path="/ClosePortal/:tabIdFromURL/Page/:id" component={ATeamBIAllProducts}  />
                <Route exact path="/AppsLibrary" component={ATeamBIAllProducts}  />
                <Route exact path="/AppsLibrary/Org/:org" component={ATeamBIAllProducts} />
                <Route exact path="/AppsLibrary/Org/App/:id" component={AppRedirect} />
                <Route exact path="/Home" component={ATeamBIAllProducts} />
                <Route exact path="/Favorites" component={Favorites} />
                <Route exact path="/ATeamBIAllProducts" component={ATeamBIAllProducts} />
                <Route exact path="/ATeamBIHome" component={ATeamBIAllProducts} />
                <Route exact path="/BoffinHome" component={BoffinHome} />
                <Route exact path="/BoffinInputs" component={BoffinInputs} />
                <Route exact path="/BoffinCompute" component={BoffinCompute} />
                <Route exact path="/BoffinViewAllItems" component={BoffinViewAllItems} />
                <Route exact path="/BoffinInputsHistory" component={BoffinInputsHistory} />
                <Route exact path="/BoffinEditItem" component={BoffinEditItem} />
                <Route exact path="/BoffinDashboards" component={BoffinDashboards} />
                <Route exact path="/BoffinNewOverride" component={BoffinNewOverride} />
                <Route exact path="/BoffinRulesAndWarnings" component={BoffinRulesAndWarnings} />
                <Route exact path="/BoffinRulesWarningsNewEdit" component={BoffinRulesWarningsNewEdit} />
                <Route exact path="/BoffinTeamNameMapping" component={BoffinTeamNameMapping} />
                <Route exact path="/BoffinCurrentPeriod" component={BoffinCurrentPeriod} />
                <Route exact path="/BoffinCipTracker" component={BoffinCipTracker} />
                <Route exact path="/BoffinBuildingTracker" component={BoffinBuildingTracker} />
                <Route exact path="/BoffinSupplierMasterList" component={BoffinSupplierMasterList} />
                <Route exact path="/BoffinWarningRules" component={BoffinWarningRules} />
                <Route exact path="/BoffinPostingSummary" component={BoffinPostingSummary} />
                <Route exact path="/Boffin" component={BoffinHome} />
                <Route exact path="/BoffinCategoryUELMapping" component={BoffinCategoryUELMapping} />
                <Route exact path="/BoffinMappingBookToLedger" component={BoffinMappingBookToLedger} />
                <Route exact path="/BoffinPrimaryLedgerToSecondaryLedgerMapping" component={BoffinPrimaryLedgerToSecondaryLedgerMapping} />
                <Route exact path="/BoffinWarningRulesOverride" component={BoffinWarningRulesOverride} />
                <Route exact path="/BoffinSupplierMasterListOverride" component={BoffinSupplierMasterListOverride} />
                <Route exact path="/BoffinUnlockCompute" component={BoffinUnlockCompute} />


                <Route exact path="/TEDHome" component={TedHome} />
                <Route exact path="/TriggerEventLogs" component={TriggerEventLogs} />
                <Route exact path="/TriggerHistory" component={TriggerHistory} />
                <Route exact path="/EmailSubscription" component={EmailSubscription} />
                <Route exact path="/EntityRegionMapping" component={EntityRegionMapping} />
                <Route exact path="/RegionTriggerMapping" component={RegionTriggerMapping} /> 
                <Route exact path="/MJEMonitoringHome" component={MJEMonitoringHome} /> 
                <Route exact path="/MJEMonitoringNewUpload" component={MJEMonitoringNewUpload} />
                <Route exact path="/MJEMonitoringHistory" component={MJEMonitoringHistory} />
                <Route exact path= "/App/:id" component={AppTemplate} /> 
                <Route exact path= "/App" component={AllTemplates} />
                <Route exact path= "/Admin" component={AdminPanel} />
                <Route exact path= "/App/:id/process" component={AddOrEditProcessPage} />
                <Route exact path= "/App/:id/AppAuditLogs" component={AppAuditLogging} />
                <Route exact path= "/App/:id/process/:pid" component={AddOrEditProcessPage} />
                <Route exact path= "/App/:id/process/:pid/FriscoProcessAuditLogs" component={FriscoAuditLoggingPage} />
                <Route exact path= "/AllAuditLogs" component={AllAuditLogs} />
                <Route exact path= "/App/:id/process/:pid/upload" component={FriscoUploadPage} />
                <Route exact path= "/App/:id/process/:pid/history" component={FriscoHistoryPage} />
                <Route exact path= "/process/redirect/:fid" component={FriscoRedirect} />
                <Route exact path= "/frisco/file/:file_id" component={FriscoFileDetails} />

                <Route exact path= "/CorpReportingHome" component={DeliverablesPage} />
                <Route exact path= "/CorpReportingHome/modules" component={ModulesPage} />
                <Route exact path= "/CorpReportingHome/deliverables" component={DeliverablesPage} />
                <Route exact path= "/CorpReportingHome/modules/:group" component={GroupPage} />
                <Route exact path= "/CorpReportingHome/admin" component={AdminPortal} />


                // will be removed soon
                <Route exact path= "/AppTemplate/:id" component={AppTemplate} /> 
                <Route exact path= "/AppTemplate" component={AppTemplate} /> 
                <Route exact path="/GeneralTools/:id" component={GeneralTools} />

                <Route exact path="/ApprovalsHome" component={ApprovalsHome} />
                <Route exact path="/ApprovalsHome/App/:id" component={ApprovalsHome} />
                <Route exact path="/ApprovalsHome/Workflow/:workflowInstanceId" component={WorkflowInstance} />

                //Logico
                <Route exact path= "/logico/upload" component={LogicoUploadPage} />
                <Route exact path= "/App/:id/LogicoProcess/:lpid/upload" component={LogicoUploadPage} />
                <Route exact path= "/App/:id/LogicoProcess" component={AddOrEditLogicoProcessPage} />
                <Route exact path= "/App/:id/LogicoProcess/:lpid" component={AddOrEditLogicoProcessPage} />
                <Route exact path= "/App/:id/LogicoProcess/:lpid/history" component={LogicoHistoryPage} />

                //FlexiCo
                <Route exact path= "/App/:id/flexico" component={AddOrEditTemplatePage} />
                <Route exact path= "/App/:id/flexico/:fid" component={AddOrEditTemplatePage} />
                <Route exact path= "/App/:id/flexico/:fid/FlexicoProcessAuditLogs" component={FlexicoAuditLoggingPage} />
                <Route exact path= "/App/:id/flexico/:fid/upload" component={FlexicoUploadPage} />
                <Route exact path= "/App/:id/flexico/:fid/history" component={FlexicoHistoryPage} />
                <Route exact path= "/flexico/redirect/:file_id" component={FlexicoRedirect} />
                <Route exact path= "/flexico/file/:file_id" component={FlexicoFileDetails} />


                //Champions Program

                <Route exact path= "/QSCApp" component={ChampionsIntake} />
                <Route exact path= "/App/:id/QSCAppMigrationDetails" component={QSCAppMigrationDetails} />
                <Route exact path= "/App/:id/QSCAppChangeRequest" component={QSCAppChangeRequest} />

                //RAC
                <Route exact path= "/RACApp" component={RACIntake} />
                <Route exact path= "/App/:id/RACAppChangeRequest" component={RACAppChangeRequest} />

                //FirstPass
                <Route exact path= "/firstpass" component={FirstPassHome} />
                <Route exact path= "/firstpass/history" component={FirstPassHistory} />


            </Switch>
        </>



    );

}
